import emailjs from "@emailjs/browser";

const SERVICE_ID = "service_4tuqcqq";
const TEMPLATE_ID = "template_083dyht";
const PUBLIC_KEY = "pXPR8lP3CgV71xnx5";

export const sendApprovalEmail = async ({ to_email, to_name }) => {
  const templateParams = {
    to_email,
    to_name,
  };

  try {
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      templateParams,
      PUBLIC_KEY
    );
    console.log("✅ Email byl odeslán:", response.status, response.text);
    return true;
  } catch (error) {
    console.error("❌ Chyba při odesílání e-mailu:", error);
    return false;
  }
};
